var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReturnIconButton(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43 0.977539C66.2085 0.977539 85.0225 19.7915 85.0225 43C85.0225 66.2085 66.2085 85.0225 43 85.0225C19.7915 85.0225 0.977539 66.2085 0.977539 43C0.977539 19.7915 19.7915 0.977539 43 0.977539Z",
    fill: "#F5F5F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43 0.977539C66.2085 0.977539 85.0225 19.7915 85.0225 43C85.0225 66.2085 66.2085 85.0225 43 85.0225C19.7915 85.0225 0.977539 66.2085 0.977539 43C0.977539 19.7915 19.7915 0.977539 43 0.977539Z",
    stroke: "#D9D9D9",
    strokeWidth: 1.95455,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_442_2038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.083 29.9691V39.7418M25.083 39.7418H34.8557M25.083 39.7418L32.6406 32.6403C34.8898 30.3949 37.8078 28.9412 40.955 28.4985C44.1022 28.0557 47.3081 28.6477 50.0895 30.1853C52.871 31.7229 55.0774 34.1229 56.3763 37.0235C57.6752 39.9241 57.9962 43.1683 57.291 46.2673C56.5858 49.3663 54.8926 52.1521 52.4664 54.205C50.0402 56.258 47.0126 57.4668 43.8397 57.6494C40.6667 57.8321 37.5204 56.9786 34.8747 55.2175C32.229 53.4565 30.2274 50.8833 29.1713 47.8857",
    stroke: "#1E1E1E",
    strokeWidth: 3.90909,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_442_2038"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 39.0909,
    height: 39.0909,
    fill: "white",
    transform: "translate(23.4541 23.4551)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturnIconButton);
export default __webpack_public_path__ + "static/media/return_icon_button.82aab5202f930de497fc9a0f4f9c340f.svg";
export { ForwardRef as ReactComponent };